<template>
  <q-dialog v-model="shown">
    <q-card
      v-if="showing"
    >
      <q-card-section
        class="row items-center"
        style="width: 500px; min-width: 500px; max-width: 500px;"
      >
        <div class="text-h6 col ellipsis">
          Select Marathon Showing
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          dense
          flat
          round
        />
      </q-card-section>
      <q-card-section class="row items-center">
        <q-table
          v-model:pagination="pagination"
          class="col"
          :columns="showingColumns"
          :rows="availableShowings"
          :rows-per-page-options="[0]"
          hide-pagination
          bordered
          flat
          wrap-cells
          row-key="id"
        >
          <template #body-cell="props">
            <q-td
              :props="props"
            >
              {{ props.value }}
            </q-td>
          </template>

          <template
            #body-cell-actions="props"
          >
            <q-td
              :props="props"
            >
              <slot
                name="row-actions"
                v-bind="props"
              >
                <div class="row q-gutter-sm justify-center no-wrap">
                  <slot
                    name="prepend-row-actions"
                    v-bind="props"
                  />
                  <q-btn
                    :hover="false"
                    label="Select"
                    @click="$emit('select-marathon-showing', props.row); shown = false"
                  />
                </div>
              </slot>
            </q-td>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'SelectMarathonShowingDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['select-marathon-showing', 'update:model-value'],
  data () {
    return {
      shown: false,
      showing: null,
      availableShowings: [],
      showingColumns: [
        { name: 'showing', align: 'left', label: 'Showing', field: 'description' },
        { name: 'actions', label: 'Actions', align: 'center' }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0
      }
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show (showing) {
      this.shown = true
      this.showing = showing
      this.availableShowings = [showing, ...showing.availableMarathonShowings]
    }
  }
}

</script>
<style lang="scss" scoped>
.action-button {
  height: 125px;
}
</style>
